import React, { useState } from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Fillers.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const Fillers = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const faqData = [
    {
      question: ' Is it safe to have filler treatment?',
      answer: 'When carried out by trained professionals using approved fillers, the treatment is completely safe and efficient.',
    },
    {
      question: 'How long do dermal fillers last?',
      answer: 'Depending on the type of filler and where it is injected, most fillers last six to eighteen months.',
    },
    {
      question: 'Is it a painful procedure?',
      answer:
        'The discomfort associated with treatment is minimal. Access to numbing cream results in an experience that is both comfortable and enjoyable for the individual receiving treatment.',
    },
    {
      question: 'After filler treatment, how much downtime is there?',
      answer:
        'There is little to no downtime. You may experience mild facial swelling around the injection site, which usually subsides within a short time.',
    },
    {
      question: 'When will I see results?',
      answer: 'Immediately after treatment, results are visible with the actual results coming within a few days.',
    },
  ]

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='fillershero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Filler
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Filler Treatment in Pitampura | Dermal Fillers for Face and Lips | Sharva Clinic
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best filler treatment in Pitampura? Get Safe and effective dermal fillers for Lips and Cheeks and Facial Regovenation
                at Sharva Clinic.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>
        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Dermal filler treatments are available at Sharva Clinic in Pitampura</h2>
              <p>
                If you&apos;re in Pitampura looking for filler treatments, we offer advanced dermal fillers. Our aesthetic specialists will not only
                bring out your natural beauty but also restore youthful volume to your face. Skin that is smoother, fuller and more young-looking can
                be achieved safely with the help of an experienced Sharva Clinic aesthetic specialist who will also provide personalized treatments.
              </p>
              <p>
                Dermal fillers are one of today&apos;s most popular non surgical cosmetic procedures that can be used to reduce wrinkles, enhance
                facial contours or improve the overall appearance of your skin.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Filler Treatment: What Is It All About?</h3>
              <p>
                Dermal fillers are injectable treatments that restore lost volume, smooth fine lines, and enhance facial features. As we age and our
                skin loses collagen, it more often sags. Eventually wrinkles develop deeper, hollow areas form around the eyes, and corners droop
                downward.
              </p>
              <p>In Sharva Clinic, Pitampura filler treatments use top-quality fillers to</p>
              <ul>
                <li>Restore facial volume</li>
                <li>Smooth wrinkles and fine lines</li>
                <li>Enhance lips and cheeks</li>
                <li>Define the jawline</li>
                <li>Reduce under-eye hollowness</li>
                <li>Give a more youthful appearance</li>
              </ul>
              <p>This treatment is quick and minimally invasive, and you&apos;ll see instant results.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Filler Injection Areas</h3>
              <p>At Sharva Clinic in Pitampura, we provide filler treatments for a variety of areas in the face, including:</p>
              <ul>
                <li>Nasolabial folds (Smile lines)</li>
                <li>Under-eye hollows</li>
                <li>Cheeks (Volume restoration)</li>
                <li>Jawline contouring</li>
                <li>Lips (Lip enhancement &amp; volume)</li>
                <li>Chin enhancement</li>
              </ul>
              <p>
                Our specialists go to great lengths to analyze your facial structure in order to ensure that you receive natural, well-balanced
                results.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits to Filler Injection Results</h3>
              <p>There are several benefits to choosing dermal filler treatments at Sharva Clinic in Pitampura:</p>
              <ul>
                <li>Non-surgical cosmetic procedure</li>
                <li>Quick treatment (usually 20–30 minutes)</li>
                <li>Minimal discomfort</li>
                <li>Visibly increased facial volume immediately</li>
                <li>Natural-looking results</li>
                <li>Little to zero downtime</li>
              </ul>
              <p>If you are at Sharva Clinic in Pitampura, you can return to your normal routine immediately afterwards.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Why You Should Choose Sharva Clinic When Looking for Filler Treatment in Pitampura</h3>
              <p>At Sharva Clinic, our aesthetic treatments are safe and advanced, and we take a patient-centered approach.</p>
              <ul>
                <li>Experience aesthetic professionals</li>
                <li>Safe, premium dermal fillers</li>
                <li>Customised plans for your treatment</li>
                <li>Advanced aesthetic tooling</li>
                <li>An emphasis on natural-looking enhancement</li>
              </ul>
              <p>
                Comfortable and hygienic environment for the clinic. Our aim is to enhance your features while still retaining the authentic
                appearance.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>Who Is A Good Candidate For Dermal Fillers?</h3>
              <p>
                If you want to reduce wrinkles and lines on the face and have the right needs, decisions and expectations, you may be a suitable
                candidate for filler treatment in Pitampura.
              </p>
              <ul>
                <li>The shape of your cheeks, mouth or smile</li>
                <li>Overall facial contours</li>
                <li>Aging with loss of volume</li>
                <li>To avoid having surgery to restore your youthful appearance in the face and brow</li>
              </ul>
              <p>A consultation with a Sharva Clinic specialist will help you identify the best plan for your skin problems.</p>
            </div>
            <div>
              <h3 style={{ fontSize: '23px' }}>What to Expect During the Procedure?</h3>
              <p>
                At Sharva Clinic, the procedure for filler treatment is simple and convenient: Consultation &amp; Facial Assessment, Treatment Areas
                Are Marked If Necessary, Numbing Cream Applied, Very Accurate Injection of Dermal Fillers, Advice Is Offered On Aftercare of The Skin.
                Both sessions take 20-30 minutes and results can be seen immediately.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb='Dr. Sweta Mishra administers dermal filler treatments at Sharva Clinique, focused on natural, balanced facial contouring.'
              profileLink='/drSweta/dermal'
            />

            <div className='faq-list'>
              <h3 style={{ fontSize: '23px' }}>FAQs - Filler Treatment in Pitampura</h3>
              {faqData.map((item, index) => (
                <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                  <div className='faq-question' onClick={() => toggleFAQ(index)}>
                    <h3>{item.question}</h3>
                    <span className='faq-icon'>{activeIndex === index ? '−' : '+'}</span>
                  </div>

                  <div className='faq-answer-wrapper'>
                    <div className='faq-answer'>
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>
            <div className='card1'>
              <p>
                “Sharva Clinic listened to what I wanted and delivered beyond expectations. My cheeks have volume again and I feel more confident.”
              </p>
              <p> — Meera </p>
            </div>
            <div className='card2'>
              <p>“Amazing experience from consultation to follow-up. My lips look perfectly balanced and not overdone. Exactly what I wanted!”</p>
              <p> — Priya </p>
            </div>
            <div className='card3'>
              <p>“Minimal swelling, fast recovery, and beautiful results. I’ll definitely return for maintenance sessions.”</p>
              <p> — Manav </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Fillers
